import {Nav, Tab} from "react-bootstrap";
import ProfileBanner from "../../components/Profile/Banner";
import ProfileForm from "../../components/Profile/profileForm";
import ProfileDiplomes from "../../components/Profile/profileDiplome";
import {useState} from "react";
import {useMe} from "../../../hooks/useGetUser";
import Loader from "../../components/shared/Loader";
import {accountStatus, userRoleList} from "../../../utils/constants";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import ProfileFormClient from "../../components/Profile/profileFormClient";
import QueryErrorState from "../../components/shared/QueryErrorState";
import {getDateLocale} from "../../../utils/date";

const ModifProfilePage = () => {
  const [activeTab, setActiveTab] = useState("Infos");
  const {data, isLoading, isError, error, refetch} = useMe();
  const {onVerifyEmail} = useUpdateTechnician();
  const [profileFile, setProfileFile] = useState(null);

  const verifEmail = () => {
    onVerifyEmail({email: data.email});
  };
  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  const {selectedRole, Technician} = data;
  return (
    <>
      {/* <PageTitle activeMenu="Mon profil" /> */}
      <div className="w-full flex flex-col px-1 lg:grid lg:grid-cols-4 gap-4">
        <ProfileBanner
          profileFile={profileFile}
          setProfileFile={setProfileFile}
          modifProfile={true}
        />
        <div className="col-span-3 w-full bg-white !py-5 !px-6 rounded-xl">
          <div className="profile-tab">
            <div className="custom-tab-1">
              <Tab.Container
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
              >
                <Nav as="ul" className="nav nav-tabs">
                  <Nav.Item as="li" role="presentation" className="nav-item">
                    <Nav.Link eventKey="Infos">Mes informations</Nav.Link>
                  </Nav.Item>

                  {selectedRole === userRoleList.TECHNICIAN && (
                    <>
                      {/* <Nav.Item as="li" className="nav-item">
                        <Nav.Link eventKey="Bio">Bio</Nav.Link>
                      </Nav.Item> */}
                      <Nav.Item as="li" role="presentation" className="nav-item">
                        <Nav.Link eventKey="Diplomes">Mes documents</Nav.Link>
                      </Nav.Item>
                      {/* <Nav.Item as="li" i className="nav-item">
                        <Nav.Link eventKey="Expertises">
                          Mes expertises
                        </Nav.Link>
                      </Nav.Item> */}
                      {/* <Nav.Item as="li" i className="nav-item">
                        <Nav.Link eventKey="Zones">
                          Zones d'interventions
                        </Nav.Link>
                      </Nav.Item> */}
                    </>
                  )}
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="Infos">
                    {selectedRole === userRoleList.TECHNICIAN ? (
                      <ProfileForm
                        profileFile={profileFile}
                        setProfileFile={setProfileFile}
                      />
                    ) : (
                      <ProfileFormClient
                        profileFile={profileFile}
                        setProfileFile={setProfileFile}
                      />
                    )}
                  </Tab.Pane>
                  {selectedRole === userRoleList.TECHNICIAN && (
                    <>
                      {/* <Tab.Pane eventKey="Bio">
                        <Bio
                          bio={data?.Technician?.bio ?? ""}
                          techId={data?.Technician?.id}
                        />
                      </Tab.Pane> */}
                      <Tab.Pane eventKey="Diplomes">
                        <ProfileDiplomes />
                      </Tab.Pane>
                      {/* <Tab.Pane eventKey="Zones">
                        <ModifProfileZones isActive={activeTab === "Zones"} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Expertises">
                        <ModifProfileExpertise />
                      </Tab.Pane> */}
                    </>
                  )}
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col justify-start items-start gap-3">
          <div className="w-full bg-white !rounded-lg flex gap-3 flex-col 2xl:!px-4 px-4 lg:!px-2 !py-4 ">
            <div className="text-left font-bold text-base text-[#19295C] mb-1 ">
              Vérifications
            </div>
            {selectedRole === userRoleList.TECHNICIAN && (
              <div className="w-full flex justify-between items-center">
                <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                  Pièce d’identité
                </span>

                {data?.Technician?.status === accountStatus.VALID ? (
                  <div className="flex gap-1 text-[#27AA00] font-semibold text-xs">
                    <span className="text-xs">Vérifiée </span>
                    <i className="fi fi-ss-check-circle flex items-center"></i>
                  </div>
                ) : (
                  <div className="flex gap-1 text-[#FF0000] font-semibold text-xs">
                    <span className="text-xs">Non Vérifiée </span>
                    <i className="fi fi-ss-circle-xmark flex items-center"></i>
                  </div>
                )}
              </div>
            )}

            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                Adresse mail
              </span>

              {!!data?.verifiedEmail ? (
                <div className="flex gap-1 text-[#27AA00] font-semibold text-xs">
                  <span className="text-xs">Vérifiée </span>
                  <i className="fi fi-ss-check-circle flex items-center"></i>
                </div>
              ) : (
                <div
                  className="flex gap-1 text-[#FF0000] font-semibold text-xs cursor-pointer"
                  onClick={verifEmail}
                >
                  <span className="text-xs underline">Vérifiez l'email </span>
                  <i className="fi fi-ss-circle-xmark flex items-center"></i>
                </div>
              )}
            </div>
            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                Numéro de téléphone
              </span>

              <div className="flex gap-1 text-[#27AA00] font-semibold text-xs">
                <span className="text-xs">Vérifié </span>
                <i className="fi fi-ss-check-circle flex items-center"></i>
              </div>
            </div>
          </div>

          {selectedRole === userRoleList.TECHNICIAN && (
            <div className="w-full bg-white !rounded-lg flex gap-3 flex-col 2xl:!px-4 px-4 lg:!px-3 !py-4 ">
              <div className="text-left font-bold text-base text-[#19295C] mb-1 ">
                Statistiques
              </div>
              <div className="w-full flex justify-between items-center">
                <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                  Interventions réalisées
                </span>

                <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[13px] leading-4">
                  {Technician?.interventionCount ?? 0}
                </div>
              </div>
              <div className="w-full flex justify-between items-center">
                <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                  Interventions réussies
                </span>

                <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[13px] leading-4">
                  {Technician?.missionCount && Technician?.interventionCount
                    ? `${Math.round(
                        (Technician.missionCount /
                          Technician.interventionCount) *
                          100
                      )}%`
                    : "--"}
                </div>
              </div>
              <div className="w-full flex justify-between items-center">
                <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                  Membre depuis
                </span>

                <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[13px] leading-4">
                  {new Date(data?.createdAt)
                    .toLocaleDateString(getDateLocale(), {
                      month: "short",
                      year: "numeric",
                    })
                    .replace(".", "")}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ModifProfilePage;
